export default "__VITE_ASSET__kLhJi1Fs__"